import { httpClient } from '@/services/http/httpClient'

export type GetTaskResponse = {
  id: string
  projectId: string
  title: string
  completed: boolean
  description: string | null
  responsableId: string | null
  startDate: string | null
  endDate: string | null
  responsable: {
    id: string
    name: string
    email: string
    image: string | null
  }
  sequence: number
  createdAt: string
  updatedAt: string
}

type GetTaskParams = {
  projectId: string
  id: string
}

export async function getTask({
  projectId,
  id,
}: GetTaskParams): Promise<GetTaskResponse> {
  const { data } = await httpClient.get<GetTaskResponse>(
    `/projects/project-tasks/${projectId}/${id}`,
  )

  return data
}
